import { BusinessCacheResolver } from './../businesses/services/business.resolver.service';
import { AllDepartmentResolver } from './../follow-ups/services/deviation.resolver.service';
import { UserEditResolver } from './../users/services/user.resolver.service';
import { EmployeeContactServices } from './services/employee-admin.service';
import { EmployeeWithLoginListResolver, BusinessNamesResolver } from './services/employee-admin.resolver.service';
import { ContactServices } from './../contact/services/contact.service';
import { EmployeeListComponent } from './components/employee-list.component';
import { CustomerEmployeeLoginComponent } from './components/customer-employee-login.component';
import { CustomerEmployeeComponent } from './components/customer-employees.component';
import { EmployeeAdminMainComponent } from './employee-admin.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { AppSharedModule } from './../shared/appShared.module';
import { NgModule } from '@angular/core';
import { KubaExportModule } from '../shared/kuba-exports/kuba-export.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

@NgModule({ exports: [
        EmployeeListComponent,
        CustomerEmployeeComponent,
        CustomerEmployeeLoginComponent,
    ],
    declarations: [
        EmployeeListComponent,
        CustomerEmployeeComponent,
        CustomerEmployeeLoginComponent
    ], imports: [AppSharedModule,
        RouterModule,
        TranslatePipe, TranslateDirective,
        KubaExportModule,
        FormsModule
    ],
    providers: [
        EmployeeContactServices,
        EmployeeWithLoginListResolver,
        BusinessNamesResolver,
        UserEditResolver,
        BusinessNamesResolver,
        BusinessCacheResolver,
        AllDepartmentResolver,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class EmployeeAdminModule { }
